import axios from 'axios';

import configs from 'config';
import { getAppInfo, getURLParameter, getAppVersion } from 'utils';
import globalConstant from 'constants/globalConstant';

const Request = axios.create({
	baseURL: configs.jarvis,
	headers: { 'Content-Type': 'application/json' },
});

const serializeError = (error) => {
	const { response } = error;
	if (!response) throw error;
	const { status, statusText, data } = response;
	const { message } = data;
	let errorMsg = '';
	try {
		errorMsg = JSON.parse(message).error.debug_msg;
	} catch (e) {
		errorMsg = message;
	}
	const errorObj = {
		name: 'API ERROR',
		message: errorMsg || statusText || `API FAILED (${status})`,
		code: status.toString(),
		stack: JSON.stringify(error.toJSON()),
	};
	return errorObj;
};

const tokenHeaderInterceptor = (config) => {
	var visa =
		getAppInfo()?.[globalConstant.URL_PARAMETER.TOKEN] ||
		getAppInfo()?.[globalConstant.URL_PARAMETER.VISA] ||
		getURLParameter(globalConstant.URL_PARAMETER.TOKEN);
	config.headers['token'] = visa;
	config.headers['latitude'] = getAppInfo()?.latitude || getURLParameter(globalConstant.URL_PARAMETER.LATITUDE) || '';
	config.headers['longitude'] =
		getAppInfo()?.longitude || getURLParameter(globalConstant.URL_PARAMETER.LONGITUDE) || '';
	config.headers['installid'] = getAppInfo()?.[globalConstant.URL_PARAMETER.INSTALL_ID] || '';
	config.headers['device'] = getAppInfo()?.[globalConstant.URL_PARAMETER.DEVICE_ID] || '';
	config.headers['simid'] = getAppInfo()?.[globalConstant.URL_PARAMETER.SIM_ID] || '';
	config.headers['appversion'] = getAppVersion() || '';
	return config;
};

const onErrorInterceptor = (error) => {
	throw serializeError(error);
};

Request.interceptors.request.use(tokenHeaderInterceptor);
Request.interceptors.response.use(undefined, onErrorInterceptor);

const extractor = (response) => {
	const { status, data, statusText } = response;
	if (status !== 200) throw new Error(statusText);
	return data;
};

export const getJarvis = (path, params) => Request.get(path, { params }).then(extractor);

export const postJarvis = (path, payload) => Request.post(path, payload).then(extractor);

export const putJarvis = (path, payload) => Request.put(path, payload).then(extractor);
